import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Route, Switch, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import Layout from '../../redux/containers/Layout';
import Home from '../../redux/containers/Home';
import Wishlist from '../../redux/containers/Wishlist';
import Search from '../../pages/Search';
import validateUser from '../../packages/api/validateUser';
import About from '../../pages/About';

import Login from '../../redux/containers/Login';
import AvatarModal from '../../redux/containers/AvatarModal';
import AnnounceModal from '../../redux/containers/AnnounceModal';
import ShareWithlistModal from '../../redux/containers/ShareWishlistModal';
import AvailabilityModal from '../../redux/containers/AvailabilityModal';
import ApplicationsModal from '../ApplicationsModal';
import LoginModal from '../../redux/containers/LoginModal';
import GlobalStyle from '../../theme/GlobalStyle';
import {tryFetchingUser, fetchUserToken} from './fetchUserToken';

const FETCH_TIMER = 60;

const App = ({ login, validation, fetchedValidation, validate, isConnected }) => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const code = query.get('code');
  const history = useHistory();
  const location = useLocation();

  const [checkedLogin, SetCheckedLogin] = useState(false);
  const [fetchTimer, SetFetchTimer] = useState(FETCH_TIMER);

  const goToLogin = () => {
    const allowedPath = ['/', '/about', '/login']
    const isNotAuth = (checkedLogin && !isConnected) || (fetchedValidation && (!validation.hasJoinedServer || !validation.hasValidatedRules))

    if(isNotAuth && !allowedPath.includes(window.location.pathname)) {
      history.push('/login');
    }
  }
  
  const fetchUserValidation = () => {
    return validateUser().then((data) => {
      validate(data);
    });
  };

  const checkLogin = async () => {
    if(!checkedLogin) {
      console.log("Checking if already logged in !")
      await tryFetchingUser(login)
      SetCheckedLogin(true);
    }
  }

  useEffect(() => {
    if(isConnected && !fetchedValidation) {
      fetchUserValidation()
    }  
  })

  useEffect(() => {
    if(code) {
      fetchUserToken(code, login);
    } else {
      tryFetchingUser(login)
    }

    checkLogin();
  }, []);

  useEffect(() => {
    goToLogin()
  }, [location, checkedLogin, fetchedValidation])

  useEffect(() => {
    if (fetchTimer <= 0) {
      fetchUserValidation();
      SetFetchTimer(FETCH_TIMER)
    } else {
      setTimeout(() => {
        SetFetchTimer(fetchTimer - 1)
      }, 1000)
    }
  }, [fetchTimer]);

  return (
    <>
      <GlobalStyle />
      <Layout>
        <Switch>
          <Route path="/" component={Home} exact />
          <Route path="/login" component={Login} />
          <Route path="/search" component={Search} />
          <Route path="/wishlist" component={Wishlist} />
          <Route path="*">
            <p>This page doesn&apos;t exist</p>
          </Route>
        </Switch>
      </Layout>
      <AvatarModal />
      <AnnounceModal />
      <ShareWithlistModal />
      <AvailabilityModal />
      <ApplicationsModal />
      <LoginModal />
    </>
  );
};

App.propTypes = {
  login: PropTypes.func.isRequired,
};

export default App;
